import { TerminalEnv } from './types'

const DEVICE_TYPES = {
  IPAD: 'ipad',
  MAC: 'macintosh',
  MAC_CLIENT: 'mac',
  IPHONE: 'iphone',
  IOS: 'ios',
  ANDROID: 'android',
  HARMONY_MOBILE: 'harmonyos-mobile',
  HARMONY_PC: 'harmonyos-pc',
  WINDOWS: 'windows',
  LINUX: 'linux',
  LANGUAGE_EN: 'language/en',
}

// 原始 UA 映射表 (Keyword -> Readable Name)
export const CLIENT_UA_MAP: Record<string, string> = {
  PHMGR: '花生壳管理',
  HSKDDNS: '花生壳ddns',
  SLCC: '向日葵主控端',
  SLRC: '向日葵客户端',
  PGYMGR: '蒲公英管理',
  PGYVISITOR: '蒲公英访问端',
  PGYVISITORENT: '蒲公英访问端企业版',
  PGYSERVER: '蒲公英服务器端',
  PGYGAME: '蒲公英联机平台',
  ORAYONION: '洋葱头',
  PGYSDWAN: '蒲公英游戏版客户端',
}

// 客户端类型映射 (Keyword -> Config Key)
const CLIENT_TYPE_MAPPING: Record<string, string> = {
  PHMGR: 'ph-mgr',
  HSKDDNS: 'hsk-ddns',
  SLCC: 'sun',
  SLRC: 'sun',
  PGYMGR: 'pgy-mgr',
  PGYVISITOR: 'pgy',
  PGYVISITORENT: 'pgy-ent',
  PGYSERVER: 'pgy-server',
  PGYGAME: 'pgy-game',
  ORAYONION: 'onion',
  PGYSDWAN: 'pgy-game',

  // 兼容旧的关键字
  SUNLOGINCONTROLCLIENT: 'sun',
  SUNLOGIN: 'sun',
}

/**
 * 解析 UserAgent 字符串，返回环境信息
 * @param userAgent
 */
export function parseUserAgent(userAgent: string): TerminalEnv {
  const ua = userAgent.toLowerCase()
  const uaOriginal = userAgent

  const isIpad = (!ua.includes(DEVICE_TYPES.MAC) || !ua.includes(DEVICE_TYPES.MAC_CLIENT)) && ua.includes(DEVICE_TYPES.IPAD)

  const isMac = (ua.includes(DEVICE_TYPES.MAC) || ua.includes(DEVICE_TYPES.MAC_CLIENT)) && !ua.includes(DEVICE_TYPES.IPAD)

  const isIphone = !!ua.includes(DEVICE_TYPES.IPHONE) || !!ua.includes(DEVICE_TYPES.IOS)
  const isAndroid = !!ua.includes(DEVICE_TYPES.ANDROID)
  const isHarmonyOSMobile = !!ua.includes(DEVICE_TYPES.HARMONY_MOBILE)
  const isHarmonyOSPC = !!ua.includes(DEVICE_TYPES.HARMONY_PC)
  const isWindows = !!ua.includes('window')
  const isLinux = ua.includes(DEVICE_TYPES.LINUX) && !ua.includes(DEVICE_TYPES.ANDROID)

  const isHarmony = isHarmonyOSMobile || isHarmonyOSPC || ua.includes('harmonyos')
  const isIos = isIphone || isIpad

  const isFlutter = (typeof window !== 'undefined' && !!window.flutter_inappwebview) || ua.includes('flutter') || ua.includes('handcake')

  const isPC = isMac || isHarmonyOSPC || isWindows || (isLinux && !isAndroid)
  const isMobile = isAndroid || isIos || isHarmonyOSMobile

  const regex = /\/([\d.]+)/
  const appVersion = ua.match(regex) && ua.match(regex)!.length >= 2 ? ua.match(regex)![1] : '0.0.0'

  const language = ua.includes(DEVICE_TYPES.LANGUAGE_EN) ? 'en-US' : 'zh-CN'

  // --- 客户端类型与名称识别 ---
  let detectedType = 'default'
  let clientName = ''

  const keys = Object.keys(CLIENT_TYPE_MAPPING).sort((a, b) => b.length - a.length)

  for (const keyword of keys) {
    if (new RegExp(keyword, 'i').test(uaOriginal)) {
      detectedType = CLIENT_TYPE_MAPPING[keyword]
      if (CLIENT_UA_MAP[keyword]) {
        clientName = CLIENT_UA_MAP[keyword]
      }
      break
    }
  }

  if (!clientName) {
    for (const [key, name] of Object.entries(CLIENT_UA_MAP)) {
      if (new RegExp(key, 'i').test(uaOriginal)) {
        clientName = name
        if (detectedType === 'default') detectedType = key.toLowerCase().replace(/_/g, '-')
        break
      }
    }
  }

  // 特定环境修正
  if (detectedType === 'sun' && isFlutter) {
    detectedType = 'sun-flutter'
  }

  if (isHarmony && detectedType === 'default') {
    detectedType = 'harmony'
  }

  return {
    ua: uaOriginal,
    isPC,
    isMobile,
    isFlutter,
    platform: {
      isMac,
      isWindows,
      isLinux,
      isAndroid,
      isIos,
      isHarmony,
      isIpad,
    },
    appVersion,
    language,
    clientType: detectedType,
    clientName,
  }
}

// 默认执行一次
export const Env: TerminalEnv = typeof navigator !== 'undefined' ? parseUserAgent(navigator.userAgent) : parseUserAgent('')
